import PropTypes from 'prop-types'
import React from 'react'
import Spinner from 'react-spinkit'

const LoadingInfo = (props) => {

  const style = {}

  if (props.size) {
    style.width = `${props.size}px`
    style.height = `${props.size}px`
  }

  return (
    <div
      className="grid-frame vertical loading-info"
    >
      <div
        className="grid-content vertical v-align align-center"
      >
        <div
          className="grid-block text-center align-center"
        >
          <div
            className="vertical"
          >
            <div className="text-center">
              <Spinner
                noFadeIn={props.noFadeIn}
                spinnerName="cube-grid"
                style={style}
              />
            </div>
            <div>
              {props.children}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

LoadingInfo.propTypes = {
  children: PropTypes.node,
  noFadeIn: PropTypes.bool,
  size: PropTypes.number,
}

export { LoadingInfo as default }



// WEBPACK FOOTER //
// ./src/LoadingInfo.js